import { JsonService } from "./JsonService";
import { FetchHttpClient, IHttpClient } from "./HttpClient";

/**
 * Response interface for anti-forgery token.
 */
export interface IAntiForgeryTokenResponse {
  /**
   * The anti-forgery token.
   */
  antiForgeryToken: string;
}

/**
 * Interface for the Anti-Forgery Service
 */
export interface IAntiForgeryService {
  /**
   * Gets the anti-forgery token.
   *
   * @returns the anti-forgery token.
   */
  getAntiForgeryToken(): Promise<string>;
}

/**
 * Implementation of the Anti-Forgery Service
 */
export class AntiforgeryService extends JsonService implements IAntiForgeryService {
  /**
   * Initializes a new instance of the AntiforgeryService class.
   *
   * @param apiVersion - The API version.
   * @param httpClient - The HTTP client.
   */
  public constructor(apiVersion: string, httpClient: IHttpClient | null = null) {
    super(apiVersion, httpClient ?? new FetchHttpClient());
  }

  /**
   * Gets the anti-forgery token.
   *
   * @returns the anti-forgery token.
   */
  public async getAntiForgeryToken(): Promise<string> {
    const response = await this.getJsonAsync<IAntiForgeryTokenResponse>(`/api/${this.apiVersion}/antiforgery`);
    return response.antiForgeryToken;
  }
}
